/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_LOGOUT, API_SERVER, API_SCT, API_GET_PUBLIC } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
import LinesEllipsis from 'react-lines-ellipsis'
import TextareaAutosize from 'react-textarea-autosize';
import ReactPlayer from 'react-player/lazy'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Loading]
-------------------------------------------------------------------*/
import ReactLoading from 'react-loading';
/*------------------------------------------------------------------
[End Loading]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Route JSON]
-------------------------------------------------------------------*/
import { route, route_name } from "./@api.json";
/*------------------------------------------------------------------
[End Route JSON]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, convertDateDBtoIndo } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = route_name;
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = route;
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [loading_stuck, set_loading_stuck] = useState(false);
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [data_story, set_data_story] = useState(null);
    const [data_entry, set_data_entry] = useState(null);
    const [data_entry_populer, set_data_entry_populer] = useState(null);

    const [search, set_search] = useState('');
    const [search_public, set_search_public] = useState('');
    const [data_user_online, set_data_user_online] = useState(null);
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')
    const [name, set_name] = useState('')
    const [title, set_title] = useState('')
    const [entry, set_entry] = useState('')
    const [url, set_url] = useState('')
    const [type, set_type] = useState('')
    const [data_notification, set_data_notification] = useState(null);
    const [notification_count, set_notification_count] = useState(0);
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket_online = () => {

        socket.on(`${route}_user_authentication`, (data) => {
			// console.log(`${route}_user_authentication : `, data)
            set_data_user_online(data)	
		})

        socket.emit(`${route}_user_authentication`, {
            action: 'connect_public',
            room: `room_${route}_user_authentication`,
            status: 'online_public',
            bamboo_user : random_character(16),
            username : random_character(16),
            name : random_character(16),
            e_account : `e_${route}`,
        });
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].bamboo;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _socket_online(STORAGE_USER[0])
            }

        }else{
            _socket_online()
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    // if(STORAGE_USER !== undefined){
    //     if(STORAGE_USER[0].level === 'guest'){
    //         history.push('/')
    //     }
    // }else{
    //     history.push('/home')
    //     window.location.reload();
    // }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search_public.length > 0){
            _search_public()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search_public])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 5)
        }

    }, [data])

    useEffect(() => {
        
        setTimeout(() => {
                
            set_loading_stuck(true) 
            
        }, 2500);

    }, [])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {

                !loading_stuck &&
                <div className="_app_loading">
                    <div className="_position_middle">
                        <ReactLoading type={'cylon'} color={'#222'} height={50} width={50} />
                        <h2 style={{marginBottom: 6}}>bigdayexport<span style={{color: 'seagreen'}}>.com</span></h2>
                    </div>				
                </div>	
            
            }
            {/* <div className="_bb-background" style={{backgroundColor: 'rgba(0,0,0,0.7'}}> */}
                <div style={{position: 'absolute', top: 20, right: 20}}>
                    <div className="_row _center_align">
                        <NavLink 
                            to={`/${route}/tender`}
                            style={{fontSize: 14, marginRight: 16}}
                        >
                            Tender
                        </NavLink>
                        <NavLink 
                            to={`/${route}/login`}
                            style={{fontSize: 14, backgroundColor: 'lightseagreen', color: '#fff', paddingTop: 6, paddingBottom: 6, paddingLeft: 18, paddingRight: 18, borderRadius: 32}}
                        >
                            Login
                        </NavLink>
                    </div>
                </div>
                {/* <div className="_container">
                    <div className="_lily_pad_h_d _push_t_d _push_b_d">
                        <h1><span style={{color: 'seagreen'}}>Big Day </span>Export</h1>
                        <p>Unduh Aplikasi Kami di <ion-icon name="logo-google-playstore" style={{marginBottom: -2}}></ion-icon> Play Store & <ion-icon name="logo-apple-appstore" style={{marginBottom: -2}}></ion-icon> App Store</p>
                    </div>
                </div> */}
            {/* </div> */}

            <div className="_container" style={{position: 'relative', zIndex: 100}}>
                <div className="_lily_pad_h_d _push_t_d _push_b_d">
                    <h1 className="_center_text" style={{marginTop: 120, marginBottom: 8}}>
                        <span style={{color: '#264653'}}>B</span>
                        <span style={{color: '#2a9d8f'}}>i</span>
                        <span style={{color: '#e9c46a'}}>g </span>
                        <span style={{color: '#f4a261'}}>D</span>
                        <span style={{color: '#e76f51'}}>a</span>
                        <span style={{color: 'lightseagreen'}}>y </span>
                        Export
                    </h1>
                    <p className="_center_text _push_b_d _cl_smooth_2">Partner Circle <b style={{color: '#444'}}>flamecore.cloud</b>, <b style={{color: '#444'}}>digitali.id</b>, <b style={{color: '#444'}}>tourmedan.com</b>, <b style={{color: '#444'}}>Plano Studio</b></p>
                    <div className="_bb_search _push_b_d" style={{borderRadius: 32, borderColor: '#ddd'}}>
                        <div className="_row _center_align">
                            <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                            <div className="_column">
                                <input 
                                    placeholder="Cari" 
                                    onChange={e => set_search(e.target.value)}
                                    value={search}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="_lily_pad_h_m">
                    <div className="_row_auto" style={{position: 'relative', borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', borderRadius: 8, overflow: 'hidden'}}>
                        <div className="_export_img" style={{backgroundImage: `url(https://cdn.jsdelivr.net/npm/mnel-image@1.0.4/grass/1.jpg)`}}>

                        </div>
                        <div className="_column_auto">
                            <div className="_lily_pad_h_s">
                                <h2>Coklat Premium</h2>
                                <p className="_cl_smooth_3">Diterbitkan Oleh <b style={{color: '#666'}}>PT. Sinar Senergi</b></p>
                                <div className="_push_t_s _push_b_s">
                                    Alamat Lengkap : Jl. Gatot Subroto Medan
                                </div>
                                <small className="_cl_smooth_3"><i>Di ekspor dengan harga</i></small>
                                <h2 style={{fontFamily: 'monospace'}}>Rp 12.000.000</h2>
                                <div className="_push_t_s">
                                    <ion-icon name="logo-whatsapp" style={{marginBottom: -3, fontSize: 16, marginRight: 4}}></ion-icon>082930291012
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    );

}

export default Screen;